import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './signin.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Verifying your email…');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Verification link is invalid or missing.');
        return;
      }

      try {
        const response = await axios.post(
          `${baseUrl}/api/verify-email`,
          { token },
          { withCredentials: true }
        );

        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message || 'Email verified successfully. You can now sign in.');
        } else {
          setStatus('error');
          setMessage(response.data.message || 'Unable to verify email.');
        }
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Unable to verify email. The link may have expired.');
      }
    };

    verify();
  }, [baseUrl, token]);

  return (
    <div className="signin-page signin-page--loading">
      <main className="signin-verify-email">
        <div className="signin-card">
          <h2>Email verification</h2>
          {status === 'loading' ? (
            <div className="signin-spinner" aria-label="Loading" />
          ) : (
            <div className={status === 'success' ? 'signin-success' : 'signin-error'} role="alert">
              {message}
            </div>
          )}
          {status !== 'loading' ? (
            <button
              type="button"
              className="signin-submit"
              onClick={() => navigate('/signin')}
            >
              Go to sign in
            </button>
          ) : null}
          <p className="signin-join">
            <Link to="/" className="signin-link">Back to home</Link>
          </p>
        </div>
      </main>
    </div>
  );
}

export default VerifyEmail;
